<template>
  <section v-if="variants.v1 === variant">
    <div class="vh-100" style="background-color: var(--seashell)">
      <div id="wrapper">
        <div class="video-content">
          <h2
            style="color: var(--white); text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2)"
            class="font-plus-jakarta-extrabold tw-text-5xl lg:tw-text-8xl"
            v-html="overlayTitle"
          ></h2>
          <div class="mt-4 tw-flex tw-items-center tw-gap-5">
            <nuxt-link
              :to="vars.mainButtonLinkUrl"
              class="pxp-search-properties-btn"
              :style="`background-color: var(--${vars.mainButtonBackgroundColor}); color: var(--${vars.mainButtonTextColor})`"
              >{{ vars.mainButtonTitleText }}</nuxt-link
            >
            <nuxt-link
              :to="vars.secondaryButtonUrl"
              class="pxp-primary-cta text-uppercase pxp-animate tw-cursor-pointer after:tw-border-white"
              :style="`color: var(--${vars.secondaryButtonTextColor})`"
              >{{ vars.secondaryButtonTitleText }}</nuxt-link
            >
          </div>
        </div>
        <div class="video-wrap">
          <video id="video-background" muted autoplay :loop="true" playsinline preload="none" :src="variables.video">
            <source type="video/mp4" :video-hd="variables.video" :video-sd="variables.video" />
          </video>
        </div>
      </div>
    </div>
  </section>
  <section class="tw-h-[100svh]" v-if="variants.v2 === variant">
    <video
      v-if="isMobileDevice && vars.mobileBackgroundVideo"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    ></video>

    <video
      v-else-if="vars.backgroundVideo"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    ></video>
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-if="vars.mobileBackgroundImage && isMobileDevice"
      :src="vars.mobileBackgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <NuxtImg
      :lazy="true"
      placeholder="blur"
      v-else-if="vars.backgroundImage"
      :src="vars.backgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <div class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-25"></div>
    <div class="tw-relative tw-z-10 tw-flex tw-h-full tw-w-full tw-items-end tw-justify-start">
      <div
        class="tw-z-100 tw-mx-3 tw-my-4 tw-mb-12 tw-flex tw-max-w-[72rem] tw-flex-col tw-gap-2 tw-text-start md:tw-mx-14 md:tw-my-10 xl:tw-mx-36 xl:tw-mb-32 xl:tw-w-[90%] xl:tw-gap-6"
      >
        <h1 class="hero-title tw-mb-6 tw-uppercase !tw-text-white">
          {{ vars.titleText }}
        </h1>
        <div
          class="tw-flex tw-flex-col tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-6 tw-gap-y-6 min-[480px]:tw-flex-row min-[480px]:tw-justify-start md:tw-mt-0 lg:tw-gap-8"
        >
          <nuxt-link :to="vars.mainButtonLinkUrl" :class="`n-${vars.mainButtonTypeText} tw-w-full md:tw-w-auto`">{{
            vars.mainButtonLabelText
          }}</nuxt-link>
          <nuxt-link
            :to="vars.secondaryButtonUrl"
            class="pxp-primary-cta text-uppercase pxp-animate tw-cursor-pointer after:tw-border-white"
            :style="`color: var(--${vars.secondaryButtonTextColor})`"
            >{{ vars.secondaryButtonTitleText }}</nuxt-link
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'VideoBackground',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  computed: {
    overlayTitle() {
      return getVariable(this.component, 'overlay_title-html');
    },

    variables() {
      return {
        video: getVariable(this.component, 'background-video'),
      };
    },
  },

  mounted() {
    try {
      const myVideo = document.getElementById('video-background');
      if (myVideo) {
        myVideo.play();
      }
    } catch (e) {
      this.$bugsnag.notify(e);
    }
  },
});
</script>

<style scoped>
#wrapper {
  position: relative;
}
#wrapper video {
  position: relative;
  z-index: 100;
}
#wrapper .video-content {
  position: absolute;
  display: block;
  z-index: 150;
  left: 3%;
  bottom: 12%;
}

.video-wrap {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  background: no-repeat center center/cover;
}
video {
  min-width: 100%;
  min-height: 100%;
  z-index: 1;
  object-fit: cover;
  background: no-repeat center center/cover;
}
</style>
